<app-title-bar
  title="Discount"
  description="Manage customer discounts and offers."
  [showButton]="true"
  buttonText="Create Discount"
  buttonVariant="primary"
  (buttonClick)="onCreateDiscount()"
>
</app-title-bar>

<!-- Search + filter + export (Location and Created Date live in the Filter modal) -->
<div class="search-filter-section">
  <app-searchbar
    placeholder="Search for discount name, type.."
    [(searchTerm)]="searchTerm"
    (searchChange)="onSearchChange($event)"
    iconSize="small"
  >
  </app-searchbar>

  <div class="filter-container">
    <app-action-button
      buttonText="Filter"
      iconSrc="assets/images/package/adjustments.svg"
      [showCount]="hasActiveFilters"
      [count]="getActiveFilterCount()"
      (buttonClick)="onFilter()"
    >
    </app-action-button>

    <!-- Same Custom Date Range export flow as Orders → Download filtered orders as CSV -->
    <div class="csv-export-wrapper">
      <app-action-button
        [buttonText]="isExporting ? 'Preparing CSV...' : 'Export'"
        [disabled]="isExporting"
        [ariaLabel]="
          isSummaryTab ? 'Export discounts summary as CSV' : 'Export custom discounts as CSV'
        "
        (buttonClick)="toggleCsvDateRangePicker()"
      >
      </app-action-button>

      <app-date-range-picker
        [isOpen]="isCsvDateRangePickerOpen"
        [selectedPeriod]="csvSelectedPeriod"
        [customDateRange]="csvDateRange"
        [periodOptions]="csvExportPeriodOptions"
        [allowReapply]="true"
        applyButtonLabel="Download CSV"
        (close)="closeCsvDateRangePicker()"
        (apply)="onCsvDateRangeApply($event)"
      >
      </app-date-range-picker>
    </div>
  </div>
</div>

<!-- Tabs -->
<app-link-nav
  [items]="navLinks"
  [activeValue]="activeTab"
  ariaLabel="Discount navigation"
  (itemSelect)="onTabChange($event)"
></app-link-nav>

<!-- Tables -->
<div *ngIf="hasRows" class="table-container" [class.is-refreshing]="loading">
  <app-listing-table
    *ngIf="isSummaryTab"
    [discounts]="summaryRows"
    [sort]="sort"
    [columnFilterMap]="summaryColumnFilterMap"
    [filters]="summaryTableFilters"
    (sortChange)="onTableSortChange($event)"
    (filterChange)="onTableFilterChange($event)"
    (viewDiscount)="onViewDiscount($event)"
    (editDiscount)="onEditDiscount($event)"
    (deleteDiscount)="onDeleteDiscount($event)"
  >
  </app-listing-table>

  <app-custom-discount-table
    *ngIf="!isSummaryTab"
    [rows]="customRows"
    [sortDirection]="sort.direction"
    (sortByCreatedDate)="toggleCreatedDateSort()"
    (viewOrder)="onViewOrder($event)"
  >
  </app-custom-discount-table>
</div>

<div *ngIf="loading && !hasRows" class="loading-container">
  <app-loading-table-shimmer
    [columns]="isSummaryTab ? summaryShimmerColumns : customShimmerColumns"
    [rows]="itemsPerPage"
    [showHeader]="true"
    className="scrollable"
  >
  </app-loading-table-shimmer>
</div>

<!-- Empty states -->
<div *ngIf="!loading && !hasRows && !hasSearchOrFilters" class="empty-state-container">
  <app-empty-result
    image="/assets/images/empty_screen.png"
    [title]="isSummaryTab ? 'No discounts yet' : 'No custom discounts yet'"
    [description]="
      isSummaryTab
        ? 'Create a discount to start offering customers a better price.'
        : 'Custom discounts applied to orders will appear here.'
    "
    [actionText]="isSummaryTab ? 'Create Discount' : ''"
    [showAction]="isSummaryTab"
    (actionClicked)="onCreateDiscount()"
  >
  </app-empty-result>
</div>

<div *ngIf="!loading && !hasRows && hasSearchOrFilters" class="empty-state-container">
  <app-empty-result
    image="/assets/images/empty_screen.png"
    title="No results found!"
    description="Please try again or modify your search or filters."
    [actionText]="''"
    [showAction]="false"
  >
  </app-empty-result>
</div>

<!-- Pagination -->
<app-pagination-bar
  *ngIf="hasRows"
  [paginationData]="paginationData"
  [itemsPerPageOptions]="itemsPerPageOptions"
  (pageChange)="onPageChange($event)"
  (itemsPerPageChange)="onItemsPerPageChange($event)"
>
</app-pagination-bar>

<!-- Filters -->
<app-filter-modal
  [isVisible]="showFilterModal"
  header="Filters"
  primaryButtonText="Apply Filters"
  secondaryButtonText="Clear Filters"
  [categories]="filterCategories()"
  [customRangeConfig]="filterModalCustomRangeConfig"
  [amountRangeConfig]="filterModalAmountRangeConfig"
  (close)="onCloseFilterModal()"
  (apply)="onApplyFilters($event)"
  (amountRangeChange)="onAmountRangeChange($event)"
  (customRangeChange)="onCustomRangeChange($event)"
  (optionChange)="onFilterOptionChange($event)"
>
</app-filter-modal>

<!-- Create / edit -->
<app-create-discount-modal
  *ngIf="showDiscountModal"
  [discount]="discountBeingEdited"
  (close)="onCloseDiscountModal()"
  (saved)="onDiscountSaved()"
>
</app-create-discount-modal>

<!-- Details -->
<app-discount-details-modal
  *ngIf="discountBeingViewed"
  [discount]="discountBeingViewed"
  (close)="onCloseDetails()"
  (edit)="onEditFromDetails($event)"
>
</app-discount-details-modal>

<!-- Delete confirmation -->
<app-confirm-action-modal
  *ngIf="discountPendingDelete"
  title="Delete this discount?"
  [message]="deleteMessage"
  confirmLabel="Delete"
  cancelLabel="Cancel"
  [busy]="deleting"
  busyLabel="Deleting..."
  (confirm)="onConfirmDelete()"
  (cancel)="onCancelDelete()"
>
</app-confirm-action-modal>
